import { render } from "./RequirePhoneModal.vue?vue&type=template&id=1c01c4e2"
import script from "./RequirePhoneModal.vue?vue&type=script&lang=js"
export * from "./RequirePhoneModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__